import { getActionRest, getAction, postAction } from '@/api/manage'

// 获取验证码
export const getCheckCode = (params) => getActionRest('/sys/randomImage/', params)
// 获取字典数据
export const getDictByCode = (params) => getActionRest('/sys/dict/getDictItems/', params)
// 花色列表
export const getDecorList = (params) => getAction('/vigour/vigourFlowerColor/flowerPageList', params)
export const getDecorById = (params) => getAction('/vigour/vigourFlowerColor/queryById', params)
// 获取文件
export const getStaticUrl = (params) => getActionRest('/sys/common/static/', params)
// 产品列表
export const getProductList = (params) => getAction('/vigour/vigourProduct/productPageList', params)
export const getProductById = (params) => getAction('/vigour/vigourProduct/queryById', params)
// 新闻列表
export const getNewsList = (params) => getAction('/vigour/vigourNews/newsPageList', params)
export const getNewsById = (params) => getAction('/vigour/vigourNews/queryById', params)
// 授权客户
export const getCustomerList = (params) => getAction('/vigour/vigourCustomer/customerPageList', params)
export const getCustomerById = (params) => getAction('/vigour/vigourCustomer/queryById', params)

// 联系我们
export const getMessageList = (params) => getAction('/vigour/vigourMessage/messagePageList', params)
export const addMessage = (params) => postAction('/vigour/vigourMessage/add', params)

// 广告
export const geAdvertisingList = (params) => getAction('/vigour/vigourAdvertising/advertisingList', params)
